import React from "react";
import { Navigate } from "react-router-dom";
import SecureLS from "secure-ls";
let ls = new SecureLS({ encodingType: "aes" });

function Protected({
  children,
  allowedRoles,
}: {
  children: React.ReactNode;
  allowedRoles?: string[];
}) {
  // Get token from localStorage instead of SecureLS
  const token = ls.get("user");
  const userData = token ? JSON.parse(token) : null;

  // If no token, redirect to login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has permission to access this route

  const isAuthorized = userData?.has_roles?.some((role: string) => allowedRoles?.includes(role));

  // If not authorized, show unauthorized message
  if (!isAuthorized) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-6">
        <h1 className="text-2xl font-bold mb-2">Unauthorized Access</h1>
        <p className="text-muted-foreground mb-6">You don't have access to this page.</p>
        <a href="/" className="bg-primary text-primary-foreground px-4 py-2 rounded-md">
          Go to Home
        </a>
      </div>
    );
  }

  // Render the protected content
  return <>{children}</>;
}

export default Protected;
